import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getTradingPartner } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetTradingPartnerRequestSchema,
  type GetTradingPartnerResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 取引先マスタ full entity 取得 hook。
 * accounts / contacts を含む全フィールドを返す。Edit modal の form 初期値に使用する。
 * id が undefined または空文字の場合は query を無効化する。
 */
export function useGetTradingPartner(
  id: string | undefined,
): UseQueryResult<GetTradingPartnerResponse, ConnectError> {
  return useQuery(
    getTradingPartner,
    create(GetTradingPartnerRequestSchema, { id: id ?? '' }),
    { enabled: id !== undefined && id !== '' },
  )
}
